import "@/Styles/inicio.css";
import useWindowsSize from "@/Hooks/useWindowsSize";
import useDessableZoom from "@/Hooks/useDesableZoom";
import {
  NewBuy,
  DesingConteiner,
  LogoIconNombreSvgV2,
  FiguraSvg,
} from "@/Components/Index";

//urls
const knowMore = "Conocer Más";
const electronic = "Electrónica";

const Inicio = () => {
  //screen de pantalla
  const { width } = useWindowsSize();
  //deshabilitar el zoom en la app
  useDessableZoom();

  const stylesv1 = {
    height: width > 1300 ? "70vh" : "60vh",
  };

  const stylesv2 = {
    height: width > 1300 ? "30vh" : "40vh",
  };

  return (
    <div className="container-fluid vh-100 position-relative">
      <div className="row h-100">
        <DesingConteiner styles={[stylesv1]}>
          <LogoIconNombreSvgV2 fill={"#d52b1e"} />
          <h3 className="develop___ColorText text-center text-title-develop">
            ¡Bienvenido a nuestro sistema de
          </h3>
          <h3
            className={`develop___ColorText text-center text-title-develop ${
              width > 1200 ? "marginbutton__logo__developargV3" : ""
            }`}>
            Pasillos Infinitos!
          </h3>
        </DesingConteiner>
        <DesingConteiner styles={[stylesv2]}>
          <div className="d-flex flex-column marginbutton__developarg">
            <NewBuy
              title={"Conocer más"}
              toLink={`/${knowMore.split(" ").join("-")}`}
              classBtn={"ps-btn develop__btn btn__developxd mb-5"}
              styles={[{ color: "#fff" }]}
            />
            <NewBuy
              title={"Comenzar"}
              toLink={`/${electronic}`}
              classBtn={"ps-btn develop__btn btn__developxd"}
              styles={[{ color: "#fff" }]}
            />
          </div>
          <div className="w-100">
            <FiguraSvg ancho={1602} alto={1073} />
          </div>
        </DesingConteiner>
      </div>
    </div>
  );
};

export default Inicio;
